(() => {
  const SCRIPT_ID = 'hok-customgpt-script';
  const CHAT_SRC = 'https://cdn.customgpt.ai/js/chat.js';
  const CONFIG = {
    p_id: '50749',
    p_key: '2a157847171f51d839b01ce5a85404cd',
  };
  const SUPPORT_PATH_RE = /\/(pages\/contact|policies)\b/i;
  let started = false;


  function loadChat() {
    if (started) return;
    started = true;

    const existingScript = document.getElementById(SCRIPT_ID);
    if (existingScript) {
      initChat();
      return;
    }

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = CHAT_SRC;
    script.defer = true;
    script.onload = initChat;
    document.head.appendChild(script);
  }

  function scheduleChat() {
    const delay = SUPPORT_PATH_RE.test(window.location.pathname) ? 1800 : 6500;
    window.setTimeout(loadChat, delay);

    ['pointerdown', 'keydown', 'touchstart'].forEach((eventName) => {
      window.addEventListener(eventName, loadChat, { once: true, passive: true });
    });

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadChat, { timeout: delay + 2500 });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleChat, { once: true });
  } else {
    scheduleChat();
  }
})();
